export const safeDecodeURIComponent = (encodedURIComponent: string): string  => {
  try {
    return decodeURIComponent(encodedURIComponent);
  } catch (e) {
    if (e instanceof URIError) {
      console.error('Caught a URI malformed error. The input string is invalid.', encodedURIComponent);
      return encodedURIComponent;
    } else {
      throw new Error(`safeDecodeURIComponent: Unexpected error: ${String(e)} | Input: ${encodedURIComponent}`);
    }
  }
};
